import React, { forwardRef } from "react";
import Popper from "@material-ui/core/Popper";
import { observer } from "mobx-react";
import StyledTooltip from "app/common/utils/StyledTooltip";
import { getTitle } from "../helpers/getTitle";

function ErrorTooltip({ store }, ref) {
  const anchorEl = store.errorTooltip.anchorEl;
  const open = Boolean(anchorEl);

  if (!store.errorTooltip.params) {
    return null;
  }

  const errorText = getTitle(store.errorTooltip.params, store.cellMetaData);
  if (!errorText) {
    return null;
  }

  return (
    <Popper open={open} anchorEl={anchorEl}>
      <StyledTooltip open={true} title={errorText} arrow>
        <div> </div>
      </StyledTooltip>
    </Popper>
  );
}

export default observer(forwardRef(ErrorTooltip));
